export type PersonalTheme = { primaryColor: number | null; backgroundColor: number | null };

export const defaultTheme: PersonalTheme = { primaryColor: null, backgroundColor: null };

export function color(hue: number, saturation: number, lightness: number) {
  return `hsl(${hue} ${saturation}% ${lightness}%)`;
}

export function contrastSafeLightness(hue: number, saturation: number, preferred: number) {
  const channel = (lightness: number, offset: number) => {
    const base = lightness / 100;
    const amplitude = (saturation / 100) * Math.min(base, 1 - base);
    const step = ((offset + hue / 30) % 12 + 12) % 12;
    const value = base - amplitude * Math.max(-1, Math.min(step - 3, 9 - step, 1));
    return value <= .04045 ? value / 12.92 : ((value + .055) / 1.055) ** 2.4;
  };
  for (let lightness = preferred; lightness >= 15; lightness--) {
    const luminance = .2126 * channel(lightness, 0) + .7152 * channel(lightness, 8) + .0722 * channel(lightness, 4);
    if (1.05 / (luminance + .05) >= 4.5) return lightness;
  }
  return 15;
}

// Twenty hues in three tones give sixty distinct, contrast-safe choices per control.
export const primaryColors = Array.from({ length: 60 }, (_, index) => {
  const hue = (index % 20) * 18;
  const tone = Math.floor(index / 20);
  const saturation = [68, 57, 75][tone]!;
  return color(hue, saturation, contrastSafeLightness(hue, saturation, [34, 30, 27][tone]!));
});

export const backgroundColors = Array.from({ length: 60 }, (_, index) => {
  const hue = (index % 20) * 18;
  const tone = Math.floor(index / 20);
  return color(hue, [32, 36, 40][tone]!, [97, 94, 91][tone]!);
});

